import { render, staticRenderFns } from "./PagosTabla.vue?vue&type=template&id=e32359fa&"
import script from "./PagosTabla.vue?vue&type=script&lang=js&"
export * from "./PagosTabla.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports